export const SET_SEARCH_BY_GROUPS = 'SET_SEARCH_BY_GROUPS'
export const SET_SEARCH_BY_COURSES = 'SET_SEARCH_BY_COURSES'
export const SET_ROLES_LEARNING_PLAN = 'SET_ROLES_LEARNING_PLAN'
export const SELECT_ROLE = 'SELECT_ROLE'
export const SET_ROLE_GROUPS = 'SET_ROLE_GROUPS'
export const SET_GROUP_SEARCH = 'SET_GROUP_SEARCH'
